import { PhaseChangeEvent as SrvgPhaseChangeEvent, Matchday, Season, Phase } from "@gaming/srvg-classes-core";

/**
 * Represents the change to another phase, or to an entirely other matchday.
 */
export class PhaseChangeEvent extends SrvgPhaseChangeEvent {
    /**
     * The new current match day.
     */
    matchday: Matchday;
    /**
     * The new current Competition.
     */
    season: Season;

    /**
     * Creates an instance of this class.
     * @param matchday The new current match day.
     * @param season The new current season.
     * @param phase The new current phase.
     */
    constructor( matchday: Matchday, season: Season, phase?: Phase ) {
        super( phase );
        this.matchday = matchday;
        this.season = season;
    }

    /**
     * Returns the string that is used to compare event types and construct handler method names. Every instance
     * has this string stored in the eventType property.
     */
    static getEventType() {
        return 'phaseChangeEvent';
    }

    /**
     * Cleanup code belongs here. Please note that this method is _NOT_ called automatically yet.
     */
    destroy() {
        this.matchday = null;
        this.season = null;
        super.destroy();
    }
}